<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{ path: '/serviceHome/serviceOrder' }">我的订单</el-breadcrumb-item>
			  <el-breadcrumb-item>订单详情</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button" @click="fanhui" style="cursor:pointer;">
				<i class="el-icon-arrow-left"></i>
				<p>返回</p>
			</div>
		</div>
		<div class="container">
			<div class="leftsidebar">
				<div class="leftsidebarTitle">
					<h3>{{datails.demand.name}}</h3>
					<p>订单编号：{{datails.order_sn}}</p>
				</div>
				<div class="leftsidebarDox">
					<div class="leftsidebarDox1">
						<h3>需求方</h3>
						<div class="leftsidebarDox1_1">
							<img :src="datails.demandUser.avatar" alt="" srcset="" />
							<div>{{datails.demandUser.nickname}}</div>
						</div>
					</div>
					<div class="leftsidebarDox2">
						<h3>订单金额</h3>
						<div>
							￥{{datails.quote_price}}
						</div>
					</div>
					<div class="leftsidebarDox1">
						<h3>服务方</h3>
						<div class="leftsidebarDox1_1">
							<img :src="datails.serveUser.avatar" alt="" srcset="" />
							<div>{{datails.serveUser.nickname}}</div>
						</div>
					</div>
				</div>
				<div class="leftsidebarTitle">
					<!-- 待支付 -->
					<el-descriptions title="订单信息" v-if="datails.status==0">
					    <el-descriptions-item label="中标时间：">{{datails.create_time}}</el-descriptions-item>
					</el-descriptions>
					<!-- 已完成 -->
					<el-descriptions title="订单信息" v-if="datails.status==5" :column="2">
					    <el-descriptions-item label="中标时间">{{datails.create_time}}</el-descriptions-item>
						<el-descriptions-item label="支付时间">{{datails.pay_time*1000 | dateFormat}}</el-descriptions-item>
					    <el-descriptions-item label="承认图验收时间">{{datails.stageOne.confirm_time*1000 | dateFormat}}</el-descriptions-item>
					    <el-descriptions-item label="承认图结算金额">￥{{datails.stageOne.price}}</el-descriptions-item>
						<el-descriptions-item label="生产图验收时间" v-if="(datails.stageTwo || {}).status==2">{{datails.stageTwo.confirm_time*1000 | dateFormat}}</el-descriptions-item>
						<el-descriptions-item label="生产图结算金额" v-if="(datails.stageTwo || {}).status==2">￥{{datails.stageTwo.price}}</el-descriptions-item>
						<el-descriptions-item label="退款阶段" v-if="datails.refund_stage==1">承认图</el-descriptions-item>
						<el-descriptions-item label="退款阶段" v-if="datails.refund_stage==2">生产图</el-descriptions-item>
						<el-descriptions-item label="生产图结算金额" v-if="(datails.stageTwo || {}).status==-2">￥{{datails.stageTwo.price}}</el-descriptions-item>
					</el-descriptions>
					<!-- 承认图阶段 -->
					<el-descriptions title="订单信息" v-if="datails.status==1 || datails.status==2" :column="2">
					    <el-descriptions-item label="中标时间">{{datails.create_time}}</el-descriptions-item>
						<el-descriptions-item label="支付时间">{{datails.pay_time*1000 | dateFormat}}</el-descriptions-item>
					    <el-descriptions-item label="承认图结算金额">￥{{datails.stageOne.price}}</el-descriptions-item>
					</el-descriptions>
					<div v-if="datails.status==1 || datails.status==2" class="anright">

							<el-badge class="item" :is-dot="datails.unread_message_count>0">
							     <el-button type="primary" style="background: #1E3A8A;border-radius:8px;" @click="liuyan(datails.o_id,datails.status)">留言</el-button>
							</el-badge>
						
					</div>
					<!-- 生产图阶段 -->
					<el-descriptions title="订单信息" v-if="datails.status==3 || datails.status==4" :column="2">
					    <el-descriptions-item label="中标时间">{{datails.create_time}}</el-descriptions-item>
						<el-descriptions-item label="支付时间">{{datails.pay_time*1000 | dateFormat}}</el-descriptions-item>
					    <el-descriptions-item label="承认图验收时间">{{datails.stageOne.confirm_time*1000 | dateFormat}}</el-descriptions-item>
						<el-descriptions-item label="承认图结算金额">￥{{datails.stageOne.price}}</el-descriptions-item>
						<el-descriptions-item label="生产图结算金额">￥{{datails.stageTwo.price}}</el-descriptions-item>
					</el-descriptions>
					<div v-if="datails.status==3 || datails.status==4" class="anright">
						
						<el-badge class="item" :is-dot="datails.unread_message_count>0">
						     <el-button type="primary" style="background: #1E3A8A;border-radius:8px;" @click="liuyan(datails.o_id,datails.status)">留言</el-button>
						</el-badge>
						
						
					</div>

					<el-descriptions title="订单信息" v-if="datails.status==-2 || datails.status==-1" :column="2">
					    <el-descriptions-item label="中标时间">{{datails.create_time}}</el-descriptions-item>
						<el-descriptions-item label="取消时间" v-if="datails.status==-1">{{datails.cancel_time*1000 | dateFormat}}</el-descriptions-item>
						<el-descriptions-item label="支付时间" v-if="datails.status==-2">{{datails.pay_time*1000 | dateFormat}}</el-descriptions-item>
					    <el-descriptions-item label="退款时间" v-if="datails.status==-2">{{datails.refund_time*1000 | dateFormat}}</el-descriptions-item>
						<el-descriptions-item label="退款金额" v-if="datails.status==-2">￥{{datails.total_price}}</el-descriptions-item>
						<el-descriptions-item label="退款阶段" v-if="datails.refund_stage==1">承认图</el-descriptions-item>
						<el-descriptions-item label="退款阶段" v-if="datails.refund_stage==2">生产图</el-descriptions-item>
					</el-descriptions>
				</div>
				
				<div class="leftsidebarTitle" v-if="hasStageOneReview">
					<el-descriptions title="评审信息（承认图）" :column="2">
					    <el-descriptions-item label="评审金支付时间">
						     {{datails.stageOne.review.pay_time*1000 | dateFormat}}
						</el-descriptions-item>
					    <el-descriptions-item label="评审参与人数">
						   <p>
							   <span style="font-size: 14px;color:#FF5900;">{{datails.stageOne.review.reviewed_count}}</span>
							   / {{datails.stageOne.review.review_num}}人
							</p>
						</el-descriptions-item>
						<el-descriptions-item label="支持需求方人数">
						    {{datails.stageOne.review.support_demand || '0'}} 人
						</el-descriptions-item>
						<el-descriptions-item label="支持服务方人数">
						    {{datails.stageOne.review.support_service || '0'}} 人
						</el-descriptions-item>
					</el-descriptions>
					<div class="leftsidebarButton">
						<div v-if="datails.stageOne.review.status !=1" @click="chakan" size="medium" style="border-radius:8px;">查看评审</div>
						<div 
						    v-if="(datails.stageOne.review || {}).status==1" 
							size="medium" type="primary" 
							style="background: #1E3A8A;border-radius:8px;color:#fff;"  
							@click="addreview(datails.stageOne.review.or_id)">
							提交评审材料
						</div>
					</div>
				</div>
				
				<div class="leftsidebarTitle" v-if="hasStageTwoReview">
					<el-descriptions title="评审信息（生产图）" :column="2">
					    <el-descriptions-item label="评审金支付时间">
						     {{datails.stageTwo.review.pay_time*1000 | dateFormat}}
						</el-descriptions-item>
					    <el-descriptions-item label="评审参与人数">
						   <p>
							   <span style="font-size: 14px;color:#FF5900;">{{datails.stageTwo.review.reviewed_count}}</span>
							   / {{datails.stageTwo.review.review_num}}人
							</p>
						</el-descriptions-item>
						<el-descriptions-item label="支持需求方人数">
						    {{datails.stageTwo.review.support_demand || '0'}} 人
						</el-descriptions-item>
						<el-descriptions-item label="支持服务方人数">
						    {{datails.stageTwo.review.support_service || '0'}} 人
						</el-descriptions-item>
					</el-descriptions>
					<div class="leftsidebarButton">
						<div v-if="datails.stageTwo.review.status !=1" @click="chakan" size="medium" style="border-radius:8px;">查看评审</div>
						<div 
						    v-if="(datails.stageTwo.review || {}).status==1" 
							size="medium" type="primary" 
							style="background: #1E3A8A;border-radius:8px;color:#fff;"  
							@click="addreview(datails.stageTwo.review.or_id)">
							提交评审材料
						</div>
					</div>
				</div>
			</div>

			<div class="rightsidebar">
				<div class="rightsidebar1" v-if="datails.status==-1">
					<h3>已取消</h3>
					<p>订单已取消，您可查看其他订单</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==-2">
					<h3>已退款</h3>
					<p>支付金额原路退回</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==0">
					<h3>待支付</h3>
					<p style="color:#ff0000;">剩余支付时间： <CountDown :endTime="datails.auto_cancel_time*1000" color="#ff0000"></CountDown></p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==1">
					<h3>待上传承认图</h3>
					<p style="color:#ff0000;">剩余交付时间： <CountDown :endTime="datails.stageOne.upload_countdown*1000" color="#ff0000"></CountDown></p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==2">
					<h3>承认图待验收</h3>
					
					<p v-if="datails.stageOne.review==null" style="color:#ff0000;">
						剩余验收时间： <CountDown :endTime="datails.stageOne.auto_confirm_time*1000" color="#ff0000"></CountDown>
					</p>
					<p v-if="datails.stageOne.review !=null">
						评审中，请您耐心等待
					</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==3">
					<h3>待上传生产图</h3>
					<p style="color:#ff0000;">
						剩余交付时间： <CountDown :endTime="datails.stageTwo.upload_countdown*1000" color="#ff0000"></CountDown>
					</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==4">
					<h3>生产图待验收</h3>
					
					<p v-if="datails.stageTwo.review==null" style="color:#ff0000;">
						剩余验收时间： <CountDown :endTime="datails.stageTwo.auto_confirm_time*1000" color="#ff0000"></CountDown>
					</p>
					<p v-if="datails.stageTwo.review !=null">
						评审中，请您耐心等待
					</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==5">
					<h3>已完成</h3>
					<p>
						感谢您使用本平台
					</p>
				</div>
				
				<div class="rightsidebar2">
					<div class="rightsidebarTitle">附件</div>
					<div class="rightsidebarbox">
						<div class="rightsidebarbox1">
							<div v-for='(i,idx) in nametype' :key="idx" :class="{'ait':idx==typeindex}" @click="qiehuan(idx)">{{i.name}}</div>
						</div>
					</div>
					<div class="rightsidebarImgbox">
						<rightsidebarImg :list="sidebarImg" :lexing="typeindex"></rightsidebarImg>
						<div class="rightsidebarAdd" v-if="(datails.status==1|| datails.status==2) && typeindex==0 && sidebarImg.length<5 && datails.stageOne.review==null">
							<el-upload
							  style="width:100%;height:44px;"
							  class="upload-demo"
							  :action="uploadActionUrl"
							  :on-remove="handleRemove"
							  :on-success="handleUploadSuccess"
							  :before-remove="beforeRemove"
							    :multiple='false'
							  :limit="5"
							  :on-exceed="handleExceed"
							  :file-list="fileList">
								 <div>
									<el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
								 </div>
							</el-upload> 
						</div>
						<p v-if="(datails.status==1|| datails.status==2) && typeindex==0 && sidebarImg.length<5 && datails.stageOne.review==null">
							单个图片/文件最大支持5M，最多不超过5次,上传后不可删除及修改，请谨慎上传。仅支持 png，jpg，pdf，zip格式
						</p>
						
						<div class="rightsidebarAdd" v-if="(datails.status==3||datails.status==4) && typeindex == 1 && sidebarImg.length<5 && datails.stageTwo.review==null">
							 <el-upload
							  style="width:100%;height:44px;"
							  class="upload-demo"
							  :action="uploadActionUrl"
							  :on-remove="handleRemove"
							  :on-success="handleUploadSuccess2"
							  :before-remove="beforeRemove"
							    :multiple='false'
							  :limit="5"
							  :on-exceed="handleExceed"
							  :file-list="fileList">
								 <div>
									<el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
								 </div>
							</el-upload> 
						</div>
						<p v-if="(datails.status==3||datails.status==4) && typeindex == 1 && sidebarImg.length<5 && datails.stageTwo.review==null">
							单个图片/文件最大支持5M，最多不超过5次,上传后不可删除及修改，请谨慎上传。仅支持 png，jpg，pdf，zip格式
						</p>
					</div>
				</div>
				
				<div class="rightsidebar2" style="margin:20px 0px;" v-if="datails.status==5">
					<div class="rightsidebarTitle">评价</div>
					<div style="display:flex;justify-content:center;">
						<el-rate v-model="rateValue"  :disabled="readonly" @change="onChange"></el-rate>
					</div>
					<p style="text-align: center;" v-if="datails.serve_score<1">请点击星星进行评分（1星最低分，5星最高）</p>
					<p style="text-align: center;" v-if="datails.serve_score==1">很糟糕</p>
					<p style="text-align: center;" v-if="datails.serve_score==2">较差</p>
					<p style="text-align: center;" v-if="datails.serve_score==3">一般</p>
					<p style="text-align: center;" v-if="datails.serve_score==4">还可以</p>
					<p style="text-align: center;" v-if="datails.serve_score==5">五星好评</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import config from '@/config/index'
	import {
		OrderDetail,
		OrderPay,
		OrderStageConfirm,
		OrderRating,
		CollectOId,
		invoicePrice,
		InvoiceApply,
		personal,
		OrderStageUpload,
	} from "@/api/api.js"
	import rightsidebarImg from '@/common/rightsidebarImg.vue';
	import CountDown from '@/common/CountDown.vue'
	export default {
	  name: 'HelloWorld',
	  components:{
		rightsidebarImg,
		CountDown
	  },
	  data() {
	    return {
		    nametype:[
				{name:"承认图"},
				{name:"生产图"}
			],
			baseURL:config.baseURL,
			typeindex:0,
			datails:{
				demand:{},
				demandUser:{},
				serveUser:{},
				stageOne:{ files: [] },
				stageTwo:{ files: [] },
				order_sn:"",
				total_price:0,
				demand_score:0
			},
			readonly:false,
			sidebarImg:[],
			invoice_price:"",
			centerDialogVisible:false,
			oId:"",
			user:"",
			fileList:[],
			ruleFormimglist:[],
			rateValue:"",
			hasStageOneReview:false,
			hasStageTwoReview:false,
	    }
	  },
	  computed: {
	  		isPersonalCenterActive() {
	  		  const p = this.$route && this.$route.path ? this.$route.path : ''
	  		  return /^\/demandHome\/(demandinvoiceList|demandUserInfo|demandPromotion)(\/|$)/.test(p)
	  		},
	  		// 完整上传地址 = baseURL + 接口路径（若后端路径不同请改下方 '/Upload/upload'）
			uploadActionUrl() {
				const base = this.baseURL || ''
				console.log(base)
				const path = (base.endsWith('/') ? '' : '/') + 'Upload/upload'
				return base + path
			},
			type(){
				return this.$route.query.type || ''
			},
			o_id() {
				return this.$route.query.o_id || ''
			}
	  },
	  mounted() {
	     this.getdatails()
	  },
	  methods: {
		  fanhui(){
		  	this.$router.go(-1)  
		  },
		normalizeFileList(files){
			if (Array.isArray(files)) return files
			if (!files) return []
			if (typeof files === 'object') {
				const values = Object.values(files).filter(Boolean)
				return values.length ? values : [files]
			}
			return []
		},
		//查看评审
		chakan(){
			const targetPath = '/serviceHome/serviceOrder/Reviewdatails?oid='+this.o_id
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		// 跳转留言  
		  liuyan(id,status){
		  	const targetPath = '/serviceHome/serviceOrder/servicmessage?oid='+id+"&status="+status
		  	if (this.$route.path !== targetPath) {
		  		this.$router.push(targetPath)
		  	}
		  },
		//提交评审材料
		addreview(or_id){
			const targetPath = '/serviceHome/serviceOrder/AddReviewDatails?or_id='+or_id
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		 handleExceed(files, fileList) {
		   this.$message.warning(`最多上传 5 个文件，当前已选 ${fileList.length} 个，本次选择了 ${files.length} 个，请勿超出限制`)
		 }, 
		 beforeRemove(file, fileList) {
		   return this.$confirm(`确定移除 ${file.name}？`)
		 },
		 handleRemove(file, fileList) {
		   this.fileList = fileList
		   const removedUrl = this.getUploadUrlFromResponse(file.response) || file.url || ''
		   if (!removedUrl) return
		   this.ruleForm.file = this.ruleForm.file.filter((url) => url !== removedUrl)
		 },
		 handleUploadSuccess(response, file, fileList) {
			let that=this
		    that.fileList = fileList
			OrderStageUpload({
				o_id:that.o_id,
				stage:"1",
				file:that.fileList[0].response.data
			}).then(res=>{
				if(res.data.status==200){
					that.getdatails()
					that.fileList=[]
				}else{
					// this.$message.error(res.data.msg);
					that.fileList=[]
				}
			})
		 },
		 onChange(e) {
		   	OrderRating(this.datails.o_id,{
		   		score:this.rateValue
		   	}).then(res=>{
		   		if(res.data.status==200){
		   			this.$message.success('评价成功');
		   			this.getdatails()
		   		}
		   	})
		},
		handleUploadSuccess2(response, file, fileList) {
			let that=this
			that.fileList = fileList
			OrderStageUpload({
				o_id:that.o_id,
				stage:"2",
				file:that.fileList[0].response.data
			}).then(res=>{
				if(res.data.status==200){
					that.getdatails()
					that.fileList=[]
				}else{
					// this.$message.error(res.data.msg);
					that.fileList=[]
				}
			})
		},
		getdatails(){
			const oid = this.o_id
			if(!oid){
				return
			}
			OrderDetail(oid,{}).then(res=>{
				const detail = res && res.data ? res.data.data : {}
				const stageOne = (detail && detail.stageOne) ? detail.stageOne : {}
				const stageTwo = (detail && detail.stageTwo) ? detail.stageTwo : {}
				const stageOneReview = stageOne ? stageOne.review : null
				const stageTwoReview = stageTwo ? stageTwo.review : null
				this.hasStageOneReview = !!(stageOneReview && typeof stageOneReview === 'object' && Object.keys(stageOneReview).length)
				this.hasStageTwoReview = !!(stageTwoReview && typeof stageTwoReview === 'object' && Object.keys(stageTwoReview).length)
				this.datails = {
					...this.datails,
					...(detail || {}),
					stageOne: {
						...stageOne,
						files: this.normalizeFileList(stageOne.files),
						review: stageOne.review
					},
					stageTwo: {
						...stageTwo,
						files: this.normalizeFileList(stageTwo.files)
					}
				}

				if(this.typeindex==0){
					this.sidebarImg = ((this.datails.stageOne && this.datails.stageOne.files) || [])
					this.sidebarImg.forEach(item=>{
						item.type=this.getFileType(item.file)
					})
					console.log(this.sidebarImg)
				}else{
					this.sidebarImg = ((this.datails.stageTwo && this.datails.stageTwo.files) || [])
					// 生产图同样需要补齐 type，否则 rightsidebarImg 会走默认 zip 图标分支
					this.sidebarImg.forEach(item=>{
						item.type=this.getFileType(item.file)
					})
				}
				if(parseInt(this.datails.serve_score)>0){
					this.rateValue=parseInt(this.datails.serve_score)
					this.readonly=true
				}else{
					this.rateValue=0
				}
			})
		},
		handleCurrentChange(){
			
		},
		qiehuan(index){
			this.typeindex=index
			this.sidebarImg=[]
			if(this.typeindex==0){
				this.sidebarImg = ((this.datails.stageOne && this.datails.stageOne.files) || [])
			}else{
				this.sidebarImg = ((this.datails.stageTwo && this.datails.stageTwo.files) || [])
			}
			this.sidebarImg.forEach(item=>{
				item.type=this.getFileType(item.file)
			})
			console.log(this.sidebarImg)
		},
		getFileType(url) {
		  const extension = url.split('.').pop().toLowerCase();
		  const typeMap = {
		    'jpg': 'image',
		    'jpeg': 'image',
		    'png': 'image',
		    'gif': 'image',
		    'zip': 'zip',
		    'rar': 'zip',
		    'pdf': 'pdf'  ,// 根据实际需求可调整
			
		  };
		  return typeMap[extension] || 'unknown';
		},
	  }
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.container{
		width:1200px;
		margin: 0 auto;
		display:flex;
		justify-content:space-between;
	}
	.leftsidebar{
		width:790px;
	}
	.rightsidebar{
		width:384px;
	}
	.leftsidebarTitle{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
	}
	.leftsidebarTitle span{
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}
	.leftsidebarDox{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
		display:flex;
		justify-content:space-between;
	}
	.leftsidebarDox1 h3{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.leftsidebarDox1_1{
		width:200px;
		display:flex;
		align-items: center;
		margin-top:12px;
	}
	.leftsidebarDox1_1 img{
		width: 32px;
		height: 32px;
		margin-right:12px;
		border-radius:50%;
	}
	.leftsidebarDox1_1 div{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
	}
	.leftsidebarDox2 h3{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.leftsidebarDox2 div{
		font-weight: bold;
		font-size: 24px;
		color: #FF5900;
		margin-top:15px;
	}
	.rightsidebar1{
		width:100%;
		height: 108px;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px;
		display:flex;
		justify-content:center;
		flex-wrap:wrap;
		flex-direction: column;
		text-align:center;
		margin-bottom:24px;
	}
	.rightsidebar1 h3{
		text-align:center;
		width:100%;
	}
	.rightsidebar1 p{
		color:#FF5900;
	}
	.rightsidebar2{
		width:100%;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px;
		padding:20px;
		box-sizing: border-box;
	}
	.rightsidebarbox{
		width:100%;
		display:flex;
		align-items: center;
		justify-content:center;
		margin-top:12px;
	}
	.rightsidebarbox1{
		width: 220px;
		height: 46px;
		background: #1E3A8A;
		border-radius: 26px 26px 26px 26px;
		border: 1px solid #FFFFFF;
		opacity: 0.6;
		padding:7px 12px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.rightsidebarbox1 div{
		width:94px;
		height:32px;
		line-height:32px;
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
		display: flex;
		text-align: center;
		justify-content: center;
		cursor:pointer;
	}
	.ait{
		background: #FFFFFF;
		border-radius: 16px;
		border: 1px solid #1E3A8A;
		color: #1E3A8A !important;
	}
	.rightsidebarAdd{
		width:100%;
		height: 44px;
		background: #FFFFFF;
		display:flex;
		justify-content: center;
		align-items: center;
/* 		border:1px dashed  #1E3A8A; */
		border-radius:8px;
		margin-top:12px;
		cursor:pointer;
	}
	.rightsidebarAdd img{
		width:16px;
		height:16px;
		margin-right:5px;
	}
	.rightsidebarAdd span{
		font-weight: 400;
		font-size: 14px;
		color: #1E3A8A;
	}
	.rightsidebarAdd button{
		width:100%;
		height:44px;
		border-radius: 12px;
	}
	.rightsidebarImgbox p{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
		margin-top:12px;
	}
	::v-deep .el-rate{
		height:36px;
	}
	::v-deep .el-rate__icon{
		font-size:28px;
	}
	::v-deep .el-button--primary{
		border:none;
	}
    ::v-deep .el-upload{
		width:100% !important;
		background: rgb(30, 58, 138) !important;
		border-radius: 12px;
	}
	::v-deep .el-button--primary{
		background: rgb(30, 58, 138) !important;
	}
	
	
	
	.anright{
		display:flex;
		justify-content:end;
	}
	.leftsidebarButton{
	    width: 100%;
	    display: flex;
	    align-items: center;
	    justify-content: flex-end;
	    margin-top: 30px;
	}

	.leftsidebarButton div{
	    padding: 5px 15px;
	    box-sizing: border-box;
	    background: rgba(30, 58, 138, 0.15);
	    border-radius: 8px;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    font-weight: 500;
	    font-size: 14px;
	    color: #1E3A8A;
	    margin-left: 10px;
	    cursor: pointer;
	}
</style>